import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'

export const ModalInfo = ({ showModal = false, setShowModal = () => { }, info = [], titulo = '' }) => {
    console.log(info)

    return (
        <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className="p-5" closeButton><h2>{titulo}</h2></Modal.Header>
            <Modal.Body>
                <div className="col-12 p-0">
                    {info.filter(item => item?.valor).length > 0 ? info.filter(item => item?.valor)?.map((item, index) => {
                        return <div key={item?.titulo} className='row col-12 d-flex justify-content-center py-2'>
                            <div className='col-12 text-left'>
                                <b>{index + 1}. {item?.titulo}</b>
                            </div>
                            <div className='col-12 text-right align-self-center'>
                                {item?.valor}
                            </div>
                        </div>
                    }
                    ) :
                        <h3 className='p-2'>No hay coberturas adicionales seleccionadas</h3>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer className="row d-flex justify-content-end mx-5">
                <button className="btn btn-primary" onClick={() => { setShowModal(false) }}>
                    Cerrar
                </button>
            </Modal.Footer>
        </Modal>
    )
}
